class YtPlayerSDK {

  constructor() {

    this.ready = new Promise((resolve, reject) => {
      window.onYouTubeIframeAPIReady = function() {
        resolve(window.YT)
      }
    })

    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  }

}

export default new YtPlayerSDK()



/** WEBPACK FOOTER **
 ** ./src/scripts/sdks/YtPlayerSDK.js
 **/